import { render, staticRenderFns } from "./NewPhotoPost.vue?vue&type=template&id=2e0e8a1b"
import script from "./NewPhotoPost.vue?vue&type=script&lang=js"
export * from "./NewPhotoPost.vue?vue&type=script&lang=js"
import style0 from "./NewPhotoPost.vue?vue&type=style&index=0&id=2e0e8a1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports